function browserStorage() {
  try { return typeof window === 'undefined' ? null : window.sessionStorage; } catch (_) { return null; }
}
const key = email => `crowd.emailCooldown:${encodeURIComponent(String(email || '').trim().toLowerCase())}`;
function readDeadline(email, storage = browserStorage()) {
  try { const value = Number(storage && storage.getItem(key(email))); return Number.isFinite(value) && value > 0 ? value : 0; }
  catch (_) { return 0; }
}
function saveDeadline(email, seconds, now = Date.now(), storage = browserStorage()) {
  const deadline = now + Math.max(1, Math.min(60, Number(seconds) || 60)) * 1000;
  try { if (storage) storage.setItem(key(email), String(deadline)); } catch (_) { /* Browser storage may be disabled. */ }
  return deadline;
}
function remainingSeconds(deadline, now = Date.now()) {
  return Math.max(0, Math.min(60, Math.ceil((deadline - now) / 1000)));
}
function retrySeconds(error) {
  const payload = error && error.response ? error.response.data : error;
  const data = payload && payload.data;
  if (data && data.limitType === 'EMAIL_COOLDOWN' && Number.isFinite(Number(data.retryAfterSeconds)) && Number(data.retryAfterSeconds) > 0)
    return Math.min(60, Math.ceil(Number(data.retryAfterSeconds)));
  return payload && payload.message === 'Too many requests. Please try again later.' ? 60 : null;
}
module.exports = { readDeadline, saveDeadline, remainingSeconds, retrySeconds };
